import { render, staticRenderFns } from "./PurchaseRequisition.vue?vue&type=template&id=f376a392&scoped=true&"
import script from "./PurchaseRequisition.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequisition.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequisition.vue?vue&type=style&index=0&id=f376a392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f376a392",
  null
  
)

export default component.exports